<script lang="ts">
  import { onMount } from 'svelte';
  import { AppState, SetIconsBackground } from '../../etc/stores';
  import Close from '../icons/Close.svelte';
  import Analytics from '../../services/analytics';
  import BackArrow from './BackArrow.svelte';
  import Label from '../typography/Label.svelte';
  import { fade } from 'svelte/transition';
  import { Container } from '../../services/container';
  import { Customer } from '../../services/customer';
  import { getHeightHeaderDash } from '../../etc/utils';

  export let hideBackArrow = false;
  export let navAnimation = false;
  export let startAnimation = false;

  export let onBack: () => void = null;
  export let title: string;

  const customer = Container.get(Customer);

  const heightHeaderDash = getHeightHeaderDash(customer.getPendingCoins());

  const closePopup = () => {
    Analytics.logEvent(
      'click-close',
      Analytics.getIsGuest() ? 'guest-state' : 'join-state'
    );

    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        popoverOpen: false
      }
    }));
  };

  export const handleNavigationBackPage = () => {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        navigationBackPage: true
      }
    }));
  };

  onMount(() => {
    SetIconsBackground('none');
  });
</script>

<div class="internal__header">
  <div
    class="internal__header-background"
    class:--animation={startAnimation}
    style={`--height-header-dash: ${heightHeaderDash}px`}
  />
  <div
    class="internal__header-wrapper"
    class:--animation={startAnimation}
    in:fade={{ duration: navAnimation ? 200 : 0 }}
  >
    {#if !hideBackArrow}
      <div class="internal__back" on:click={onBack}>
        <BackArrow onClick={onBack} fixed themed />
      </div>
    {/if}
    <div class="internal__title" class:no-back-arrow={hideBackArrow}>
      <Label type="default-semibold" color="#FFF" textAlign="center">
        {title}
      </Label>
    </div>
    <div class="internal__close" on:click={closePopup}>
      <Close themed />
    </div>
  </div>
</div>

<style lang="scss">
  .internal {
    &__header {
      width: 100%;
      min-height: 62px;
      box-sizing: border-box;
      padding: 16px 24px;
      isolation: isolate;
      z-index: 1;
      position: relative;

      &-background {
        @keyframes fly-animation {
          from {
            transform: translateY(
              calc(calc(var(--height-header-dash) - 62px) * -1)
            );
          }
          to {
            transform: translateY(0);
          }
        }

        position: absolute;
        inset: 0;
        background: var(--twism-theme-background);
        background-size: cover;
        z-index: -1;
        height: var(--height-header-dash);
        transform: translateY(
          calc(calc(var(--height-header-dash) - 62px) * -1)
        );

        &.--animation {
          animation: fly-animation 0.3s forwards;
          animation-delay: 0.3s;
        }
      }
      &-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: opacity 0.3s;

        &.--animation {
          opacity: 0;
        }
      }
    }

    &__back {
      width: 30px;
      height: 30px;
      background: var(--twism-theme-illustration-quaternary);
      mix-blend-mode: normal;
      border-radius: 8px;
      position: relative;
      overflow: hidden;

      @media screen and (min-width: 768px) {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          pointer-events: none;
          background: rgba(0, 0, 0, 0.1);
          transition: opacity 0.2s ease-in-out;
        }

        &:hover:before {
          opacity: 1;
        }

        :global(.back-arrow) {
          z-index: 5;
        }
      }
    }

    &__close {
      width: 30px;
      height: 30px;
      background: var(--twism-theme-illustration-quaternary);
      mix-blend-mode: normal;
      border-radius: 8px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      @media screen and (min-width: 768px) {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          pointer-events: none;
          background: rgba(0, 0, 0, 0.1);
          transition: opacity 0.2s ease-in-out;
        }

        &:hover:before {
          opacity: 1;
        }

        :global(.twism-close) {
          z-index: 5;
        }
      }
    }

    &__title {
      outline: none;
      text-transform: none;
      margin-top: 0;

      &.no-back-arrow {
        flex-grow: 1;
        padding-left: 30px;
      }
    }
  }
</style>
